import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';
import { buildQueryParams } from '../../utils/object';

export const infestationParametersApi = createApi({
  reducerPath: 'infestationParametersApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),

  tagTypes: ['Infestation Parameters'],

  endpoints: (builder) => ({
    getInfestationParameters: builder.query({
      query: ({ cropId, infestationId, season, search, page, limit } = {}) => ({
        url: 'infestation-parameters',
        params: buildQueryParams({ crop: cropId, infestation: infestationId, season, search, page, limit }),
      }),
      providesTags: ['Infestation Parameters'],
    }),

    getInfestationParametersMeta: builder.query({
      query: () => ({
        url: 'infestation-parameters/meta',
      }),
    }),

    addInfestationParameters: builder.mutation({
      query: (payload) => ({
        url: 'infestation-parameters/create',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Infestation Parameters'],
    }),

    updateInfestationParameters: builder.mutation({
      query: ({ id, payload }) => ({
        url: `infestation-parameters/update/${id}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['Infestation Parameters'],
    }),

    uploadInfestationParameters: builder.mutation({
      query: ({ crop_slug, season, pruningType, file, override_duplicates }) => {
        const formData = new FormData();
        formData.append('crop_slug', crop_slug);
        if (season) formData.append('season', season);
        if (pruningType) formData.append('pruning', pruningType);
        formData.append('file', file);
        formData.append('override_duplicates', override_duplicates);

        return {
          url: 'infestation-parameters/upload',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Infestation Parameters'],
    }),

    downloadInfestationParameters: builder.query({
      query: ({ crop_slug, season }) => ({
        url: 'infestation-parameters/download',
        params: {
          crop_slug,
          ...(season ? { season } : {}),
        },
        responseHandler: (response) => response.blob(),
      }),
      providesTags: ['Infestation Parameters'],
    }),
  }),
});

export const {
  useGetInfestationParametersQuery,
  useGetInfestationParametersMetaQuery,
  useAddInfestationParametersMutation,
  useUpdateInfestationParametersMutation,
  useUploadInfestationParametersMutation,
  useLazyDownloadInfestationParametersQuery,
} = infestationParametersApi;
